/** Button label for a notification's destination. Keys match PUSH_DESTINATION_PATHS. */
const ACTION_LABELS: Readonly<Record<string, string>> = Object.freeze({
  DASHBOARD: "Open dashboard",
  BOOSTER_LOAN: "View booster loan",
  PORTFOLIO: "View portfolio",
  DISCOVERY: "Explore",
  REFER_FRIEND: "Refer a friend",
  TRANSFER: "Go to transfer",
  SETTINGS: "Open settings",
});

export function notificationActionLabel(screen?: string | null): string {
  const key = (screen || "").trim().toUpperCase();
  return Object.prototype.hasOwnProperty.call(ACTION_LABELS, key) ? ACTION_LABELS[key] : "View";
}
